export default "__VITE_ASSET__DvcirCEg__"